import React from 'react';
import classNames from 'classnames';
import styles from './indicator.module.scss';

interface IndicatorProps {
  numberOfSlides: number;
  selectedSlide: number;
}

// We want the indicators to display
// differently based on how far away they are
// from the selected slide.
const HIDE_INDICATOR_DISTANCE = 4;
const SMALL_INDICATOR_DISTANCE = 3;
const MED_INDICATOR_DISTANCE = 2;

const Indicator = ({ numberOfSlides, selectedSlide }: IndicatorProps) => (
  <ul className={styles.container} aria-hidden>
    {Array.from({ length: numberOfSlides }, (id, index) => {
      return (
        <li
          key={index}
          className={classNames(styles.indicator, {
            [styles.selected]: index === selectedSlide,
            [styles.hide]:
              Math.abs(selectedSlide - index) > HIDE_INDICATOR_DISTANCE,
            [styles.small]:
              Math.abs(selectedSlide - index) > SMALL_INDICATOR_DISTANCE,
            [styles.med]:
              Math.abs(selectedSlide - index) > MED_INDICATOR_DISTANCE,
          })}
        />
      );
    })}
  </ul>
);

export default Indicator;
